import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import JustRouterView from "./modules/general/JustRouterView.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "Collections",
        component: () => import(/* webpackChunkName: "search" */ "./modules/search/views/SearchPage.vue"),
        meta: { unauthenticated: true },
    },
    {
        path: "/latest-images",
        name: "artwork-latest-images-details",
        component: () => import(/* webpackChunkName: "artwork-page" */ "./modules/artwork/views/ArtworkGrid.vue"),
        meta: { unauthenticated: true },
    },
    {
        path: "/samlinger",
        component: JustRouterView,
        children: [
            {
                path: ":id",
                name: "ArtworkPage",
                component: () =>
                    import(/* webpackChunkName: "artwork-page" */ "./modules/artwork/views/ArtworkPage.vue"),
            },
        ],
        meta: { unauthenticated: true },
    },
    {
        path: "/museums",
        component: JustRouterView,
        children: [
            {
                path: "",
                name: "Museums",
                component: () =>
                    import(/* webpackChunkName: "museums-page" */ "./modules/museums/views/MuseumsPage.vue"),
            },
        ],
        meta: { unauthenticated: true },
    },
    {
        path: "/about-page",
        component: JustRouterView,
        children: [
            {
                path: "",
                name: "About",
                component: () => import(/* webpackChunkName: "about-page" */ "./modules/about/views/AboutPage.vue"),
            },
        ],
        meta: { unauthenticated: true },
    },
    // Add a redirect for the old path to maintain backward compatibility
    {
        path: "/samlinger",
        redirect: "/",
        meta: { unauthenticated: true },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        // prevent scroll on search page
        // during pagination and changing filters
        if (from.name === "Collections" && to.name === "Collections") {
            return;
        }
        // if hash link => /page#section
        // scroll smoothly to desired position
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: "smooth",
            };
        }
        // else if redirect to Collections scroll to savedPosition or top
        else if (to.name === "Collections") {
            if (savedPosition) savedPosition.behavior = "smooth";
            return savedPosition ?? { left: 0, top: 0 };
        }
        // else just scroll to top
        else {
            return { left: 0, top: 0 };
        }
    },
});

export default router;
